import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/UserProfile.css'; // Optional styling

const UserProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState('');

  const apiBase = '/backend/api';

  const fetchProfile = (email) => {
    return axios
      .post(`${apiBase}/get_user_profile.php`, { email }, { withCredentials: true })
      .then((res) => {
        if (res.data.status === 'success') {
          setUser(res.data.user);
          return res.data.user;
        }
        alert(res.data.message || "User not found");
        return null;
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
        alert("Failed to load profile. Please check the server.");
        return null;
      });
  };

  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    if (!email) {
      alert("No user email found. Please log in first.");
      setLoading(false);
      return;
    }

    fetchProfile(email).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="upx-loading">Loading profile...</div>;
  if (!user) return <div className="upx-error">No user data found.</div>;

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordMessage('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordMessage('Please fill all password fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordMessage('New password and confirm password do not match.');
      return;
    }
    if (newPassword.length < 8) {
      setPasswordMessage('New password must be at least 8 characters long.');
      return;
    }

    setSavingPassword(true);
    try {
      const res = await axios.post(
        `${apiBase}/change_password.php`,
        { currentPassword, newPassword },
        { withCredentials: true }
      );

      if (res.data.status === 'success') {
        setPasswordMessage(res.data.message || 'Password updated successfully.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        // Password change shouldn't log you out, but refresh UI state/message.
        const email = localStorage.getItem('userEmail');
        if (email) await fetchProfile(email);
      } else {
        setPasswordMessage(res.data.message || 'Failed to update password.');
      }
    } catch (err) {
      console.error('Change password failed:', err);
      setPasswordMessage('Failed to update password. Please check your current password and try again.');
    } finally {
      setSavingPassword(false);
    }
  };

  return (
    <div className="upx-container">
      <div className="upx-card">
        <h2 className="upx-title">👤 User Profile</h2>
        <div className="upx-info"><strong>Username:</strong> {user.username}</div>
        <div className="upx-info"><strong>Email:</strong> {user.email}</div>
        <div className="upx-info"><strong>Phone Number:</strong> {user.phone_number || 'N/A'}</div>
        <div className="upx-info"><strong>Address:</strong> {user.address || 'N/A'}</div>

        <div className="upx-divider" />

        <h3 className="upx-subtitle">Change Password</h3>
        <form className="upx-form" onSubmit={handleChangePassword}>
          <label className="upx-label">
            Current Password
            <input
              className="upx-input"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          <label className="upx-label">
            New Password
            <input
              className="upx-input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          <label className="upx-label">
            Confirm New Password
            <input
              className="upx-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          <button className="upx-button" type="submit" disabled={savingPassword}>
            {savingPassword ? 'Updating...' : 'Update Password'}
          </button>

          {passwordMessage ? (
            <div className={passwordMessage.toLowerCase().includes('success') ? 'upx-success' : 'upx-error-message'}>
              {passwordMessage}
            </div>
          ) : null}
        </form>
      </div>
    </div>
  );
};

export default UserProfile;
